/* eslint no-unneeded-ternary: 0 */
/* eslint array-callback-return: 0 */
/* eslint no-confusing-arrow: 0 */
/* eslint consistent-return: 0 */
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { AppInstancesRepository, DevicesRepository, AppIntegrationsRepository, LicensesRepository, AppPricesRepository } from 'common/repositories/index';
import { AppInstancesProcessor, AppIntegrationsInactiveProcessor, DevicesProcessor, IssuesProcessor } from 'common/repositoryProcessors/index';
import log from 'common/services/logging/loggers';

/**
 * Controller for the device details page
 */


angular.module('controllers')

    .controller(
        'DeviceDetails',
        (
            $scope, $filter, $state, $translate, $stateParams,
            AppInstanceRestService, PaymentUrlsRestService,
            Util, $window,
        ) => {

            $scope.state = $state;
            $scope.processedInstances = [];
            $scope.deviceId = $state.params.resourceId;
            $scope.device = DevicesRepository.getById($scope.deviceId);
            $scope.brandName = CWCONFIG.partnerConfig.name;
            if (!$scope.device) {

                return $state.go('root.dashboard.devices');

            }

            $scope.browserName = $window.browserName.toLowerCase();

            // get details of free bundle current offer
            let defaultDeployedAppId;
            if ($scope.device.attributes.os === 'windows') {

                defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.windows || 'sptl1';

            } else if ($scope.device.attributes.os === 'osx') {

                defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.osx || 'fass0';

            }
            $scope.featuredApp = AppIntegrationsRepository.getById(defaultDeployedAppId) || {};

            $scope.showFSSDownloadButton = category => !!(category === 'fss_apps'
                && $scope.servicesByCategory[category].inactive.length > 0
                && ($scope.device.attributes.os === 'windows' || $scope.device.attributes.os === 'osx'));

            /**
             * Get the details of the app of the current offer
             */
            const offerProductId = 'aps10';
            $scope.offerProductDetails = AppIntegrationsRepository.getById(offerProductId);

            /**
             * Model to group the instances of the current device by their category
             */
            $scope.servicesByCategory = {
                fss_apps: {
                    inactive: [],
                    active: [],
                },
                browser_extensions: {
                    inactive: [],
                    active: [],
                },
                internet_of_things: {
                    inactive: [],
                    active: [],
                },
            };

            // store license/licenses names that are installed on the current device
            $scope.licenseNames = [];
            $scope.deviceAppInstances = AppInstancesProcessor
                .getInstancesByDevice($scope.device.relationships.user.data.id, $scope.deviceId);

            if ($scope.deviceAppInstances) {

                /**
                 * Get the license name for each active instance on the device
                 * Only paid licenses are needed
                 */
                $scope.deviceAppInstances.forEach((instance) => {

                    if (instance && instance.attributes.state === 'active') {

                        const instanceLicense = LicensesRepository
                            .getLicenseById(instance.relationships.license.data.id);

                        if (instanceLicense) {

                            const integrationDetails = AppIntegrationsRepository
                                .getById(instanceLicense.relationships.app.data.id);

                            if (integrationDetails) {

                                const { oeName } = integrationDetails.attributes.resource;

                                // make sure not to store doubles
                                if ($scope.licenseNames.indexOf(oeName) === -1) {

                                    $scope.licenseNames.push(oeName);

                                }

                            }

                        }


                    }

                });

            }

            $scope.hasAv = false;

            const isMobileDevice = DevicesRepository.isMobile($scope.deviceId);
            const issueSeparator = ', ';
            let isProInstalled = '';

            const tabs = ['apps', 'events', 'info'];
            const isValidTab = tabs.indexOf(($stateParams.tab || '')) >= 0;

            // check if the device details tab is available
            if (isValidTab) {

                // if device doesn't exists, go to dashboard
                if (!$scope.device) {

                    return $state.go('root.dashboard.home');

                }

            } else {

                return $state.go('root.dashboard.device-details', {
                    resourceId: $stateParams.resourceId,
                    tab: 'apps',
                });

            }

            $scope.detectDeviceIssues = () => {

                $scope.deviceIssues = [];
                $scope.issuesAvModules = '';
                _.each($scope.instancesWithIssues, (issue) => {

                    if (issue &&
                        String(issue.relationships.device.data.id) === String($scope.deviceId)) {

                        if (issue.attributes.status.svc.guard === 2 ||
                            issue.attributes.status.svc.guard === 4 ||
                            issue.attributes.status.svc.guard === 0) {

                            $scope.deviceIssues.push('guard');
                            $scope.issuesAvModules +=
                                $translate.instant('cw.dashboard.services.windows.antivirus.guard.name') + issueSeparator;

                        }
                        if (issue.attributes.status.svc.firewall === 2 ||
                            issue.attributes.status.svc.firewall === 4 ||
                            issue.attributes.status.svc.firewall === 0) {

                            $scope.deviceIssues.push('firewall');
                            $scope.issuesAvModules +=
                                $translate.instant('cw.dashboard.services.windows.antivirus.firewall.name') + issueSeparator;

                        }
                        if (issue.attributes.status.svc.mailguard === 2 ||
                            issue.attributes.status.svc.mailguard === 4 ||
                            issue.attributes.status.svc.mailguard === 0) {

                            $scope.deviceIssues.push('mailguard');
                            $scope.issuesAvModules +=
                                $translate.instant('cw.dashboard.services.windows.antivirus.mailguard.name') + issueSeparator;

                        }
                        if (issue.attributes.status.svc.webguard === 2 ||
                            issue.attributes.status.svc.webguard === 4 ||
                            issue.attributes.status.svc.webguard === 0) {

                            $scope.deviceIssues.push('webguard');
                            $scope.issuesAvModules +=
                                $translate.instant('cw.dashboard.services.windows.antivirus.webguard.name') + issueSeparator;

                        }

                    }

                });

                if ($scope.issuesAvModules) {

                    $scope.issuesAvModules = $scope.issuesAvModules
                        .slice(0, $scope.issuesAvModules.length - issueSeparator.length);

                }

                if ($scope.device) {

                    $scope.hasAv =
                        DevicesProcessor.hasAvInstalled(
                            $scope.device.relationships.user.data.id,
                            $scope.deviceId,
                        );

                }

            };

            /*  lock/unlock functionality is available only for PC's/Laptops
            with Windows operating system */
            function checkLockAvailability() {

                return !isMobileDevice &&
                $scope.device.attributes.os === 'windows' ? true : false;

            }

            // returns lock status {boolean}
            function checkDeviceLockStatus() {

                return $scope.device.attributes.locked;

            }

            $scope.isDeviceLocked = checkDeviceLockStatus();
            $scope.isLockFunctionalityAvailable = checkLockAvailability();

            // direct binding for issues
            const issuesObservable = IssuesProcessor.getObservable();
            issuesObservable.subscribe((data) => {

                $scope.instancesWithIssues = _.values(data);
                $scope.detectDeviceIssues();

            }, () => { }, () => { });


            // direct binding for devices
            const deviceObservable = DevicesRepository.getObservable();
            const onNextDevice = () => {

                $scope.device = DevicesRepository.getById($scope.deviceId);

                // goToDevices if the devices was removed or hidden
                if (!$scope.device || $scope.device.attributes.hidden) {

                    return $state.go('root.dashboard.devices');

                }

                // detect if the device has info (OS, HDD, RAM, CPU etc...)
                const deviceSectionKeys = [
                    'disks', 'partitions', 'cpu', 'gpus', 'memory', 'motherboard', 'resolution',
                    'osver', 'sp', 'totalSpace', 'freeSpace', 'batteryLevel',
                    'osver', 'imei', 'serial', 'phoneNo', 'systemInfo',
                ];
                const deviceOthersKeys = _.keys($scope.device.attributes.others);

                $scope.deviceInfo =
                    _.find(deviceOthersKeys, item => deviceSectionKeys.indexOf(item) > -1);

                // after updating DeviceRepository, check device lock status
                $scope.isDeviceLocked = checkDeviceLockStatus();

            };

            const devicesSubscriber =
                deviceObservable.subscribe(onNextDevice, () => { }, () => { });

            const filterInstances = (devices) => {

                const currentDeviceHasInstances =
                    Object.keys(devices).indexOf($scope.deviceId) !== -1;
                let processedInstances = [];

                if (currentDeviceHasInstances) {

                    const currentDeviceInstances = devices[$scope.deviceId];
                    const hiddenInstances = [];

                    // to filter browser extensions that are compatible for device
                    const deviceCompatibleExtensions = (instance) => {

                        // browser not supported, skip this filter
                        if (Util.deepFind(instance, 'customAppInfo.browsers') &&
                            instance.customAppInfo.browsers.indexOf($scope.browserName) === -1) {

                            return false;

                        }

                        const compatibleProductBrowsers = Util.deepFind(instance, 'customAppInfo.browsers');
                        const isBrowserExtension = compatibleProductBrowsers !== undefined;

                        const isPendingInstance = Util.deepFind(instance, 'attributes.state') === 'pending';

                        // if instance is not a browser extension so we skip this filter
                        if (!isBrowserExtension) {

                            return true;
                            // but if it is a browser extension and it's state is not pending
                            // (product is installed), we display it in the view

                        } else if (!isPendingInstance) {

                            return true;

                        }

                        const deviceHasBrowsers = Util.deepFind($scope.device, 'attributes.others.browsers');

                        if (!deviceHasBrowsers) {

                            return false;

                        }

                        const deviceBrowserListString = deviceHasBrowsers
                            .map(browser => browser.name && browser.name.toLowerCase())
                            .reduce((previous, current) => `${previous}.${current}`, '');

                        const canBeInstalled = compatibleProductBrowsers
                            .filter(browser => deviceBrowserListString.indexOf(browser) !== -1);

                        if (canBeInstalled.length > 0) {

                            return true;

                        }

                        return false;

                    };

                    currentDeviceInstances
                        .map((data) => {

                        // we only hide instances that have been explicitly hidden
                        // - i.e. have the visible attribute = 0
                            const instanceCanBeShown = data.customAppInfo.visible !== 0 &&
                            data.customAppInfo.name ?
                                true :
                                false;

                            // check if instance is already added
                            const instanceExists =
                                _.find(
                                    processedInstances,
                                    instance =>
                                        instance.relationships.app.data.id ===
                                            data.relationships.app.data.id,
                                );

                            if (!instanceExists && instanceCanBeShown) {

                                processedInstances.push(data);

                            }

                            if (!instanceCanBeShown) {

                                hiddenInstances.push(data);

                            }

                            isProInstalled = isProInstalled ||
                                             data.relationships.app.data.id === 'aasc0' ||
                                             data.relationships.app.data.id === 'mspa0' ||
                                             data.relationships.app.data.id === 'mspi0';


                        });

                    if (processedInstances.length > 0) {

                        processedInstances = processedInstances
                            .filter(deviceCompatibleExtensions);

                    }

                    if (hiddenInstances.length > 0) {

                        log.log({
                            type: 'Product Catalog - hidden instances',
                            cmd: '',
                            data: hiddenInstances,
                        });

                    }

                }

                return processedInstances;

            };
            // end

            /**
             * Check if an instance is installed on current device
             * If the instance's relationship attribute is an empty object,
             * the instance is not installed
             *
             * Note: the instances were filtered before to only be for the current device
             */
            $scope.isInstalled = instanceRelationship => !angular.equals({}, instanceRelationship);

            /**
             * Whenever an observable for the active instances or
             * inactive integrations is triggered, sort the new data to it's specific
             * category in servicesByCategory model
             *
             * @param {*} services Array of either instances or inactive integrations
             * @param {*} servicesType String active/inactive
             */
            const sortServicesToCategory = (services, servicesType) => {

                /**
                 * Every time the method is called with new data, we need to reset
                 * clear all data for all categories of the serviceType before push the new data
                 *
                 * E.g. clear all inactive values for all the categories
                 */
                Object.keys($scope.servicesByCategory).forEach((key) => {

                    $scope.servicesByCategory[key][servicesType] = [];

                });

                // loop through all the services and store each integration in designated category
                services.forEach((integration) => {

                    // e.g. antivirus
                    const serviceName = integration.attributes.prototype ||
                        integration.attributes.service;

                    if (serviceName !== 'iot' || $scope.device.attributes.os !== 'windows') {

                        let category = CWCONFIG.servicesByCategoryDeviceDetails[serviceName];

                        if (category === 'browser_extensions' &&
                            ($scope.device.attributes.os === 'ios' ||
                            $scope.device.attributes.os === 'android')) {

                            category = 'fss_apps';

                        }

                        if (category && servicesType) {

                            $scope.servicesByCategory[category][servicesType].push(integration);

                        }

                    }

                });

            };

            /* 1. direct binding for instances
            2. Instances must be filtered before integrations.
           This condition will remain until we will fix Family Locator acronym */
            const instancesObservable = AppInstancesProcessor.getObservable();
            const onNextInstance = (data) => {

                // if we actually have an instance, do we bother to filter
                if (data.length > 0) {

                    const filteredInstances =
                        filterInstances(data[$scope.device.relationships.user.data.id]);

                    sortServicesToCategory(filteredInstances, 'active');

                }

            };
            const instancesSubscriber =
                instancesObservable.subscribe(onNextInstance, () => { }, () => { });


            // for each device we look for its integrations and hide
            // them from the view if they can't be shown in the view
            function filterIntegrations(devices) {

                const currentDeviceHasIntegrations =
                    Object.keys(devices).indexOf($scope.deviceId) !== -1;

                let filteredIntegrations = [];

                // we show items that pass both filters,
                // both only log items that don't pass the second
                if (currentDeviceHasIntegrations) {

                    const currentDeviceIntegrations = devices[$scope.deviceId];
                    const hiddenIntegrations = [];

                    const firstFilter =
                        integration =>
                            (integration.attributes.custom.manifest.visible === 1 ||
                            integration.attributes.custom.manifest.visible === 3) &&
                            integration.attributes.custom.manifest.scope !== 'user' &&
                            (!isProInstalled || (isProInstalled && integration.id !== 'free0')) ?
                                true :
                                false;

                    const deviceCompatibleExtensions = (integration) => {

                        // browser not supported, skip this filter
                        const productManifest = integration.attributes.custom.manifest;
                        if (Util.deepFind(integration, 'attributes.custom.manifest.browsers') &&
                            productManifest.browsers.indexOf($scope.browserName) === -1) {

                            return false;

                        }

                        const compatibleProductBrowsers = Util.deepFind(integration, 'attributes.custom.manifest.browsers');
                        const isBrowserExtension = compatibleProductBrowsers !== undefined;

                        // integrations is not a browser extension so we skip this filter
                        if (!isBrowserExtension) {

                            return true;

                        }

                        const deviceHasBrowsers = Util.deepFind($scope.device, 'attributes.others.browsers');

                        if (!deviceHasBrowsers) {

                            return false;

                        }

                        const deviceBrowserListString = deviceHasBrowsers
                            .map(browser => browser.name && browser.name.toLowerCase())
                            .reduce((previous, current) => `${previous}.${current}`, '');

                        const canBeInstalled = compatibleProductBrowsers
                            .filter(browser => deviceBrowserListString.indexOf(browser) !== -1);

                        if (canBeInstalled.length > 0) {

                            return true;

                        }

                        return false;

                    };

                    // only log elements to console if they don't pass this filter
                    const lastFilter = (integration) => {

                        const filterCondition = integration.attributes.custom.manifest.name &&
                        integration.attributes.custom.manifest.os ?
                            true :
                            false;

                        if (!filterCondition) {

                            hiddenIntegrations.push(integration);

                            return false;

                        }
                        return true;

                    };
                    // because SPTL1 doesn't return instance of Privacy Pal so we hide it
                    const isPrivacyPalNotInstalled = (integration) => {

                        hiddenIntegrations.push(integration);
                        return !(integration.id === 'pg001' && !$scope.isInstalled(integration.relationships));

                    };

                    filteredIntegrations = currentDeviceIntegrations
                        .filter(firstFilter)
                        .filter(deviceCompatibleExtensions)
                        .filter(lastFilter)
                        .filter(isPrivacyPalNotInstalled);

                    if (hiddenIntegrations.length > 0) {

                        log.log({
                            type: `Product Catalog - hidden integrations for device with id - ${$scope.deviceId}`,
                            cmd: '',
                            data: hiddenIntegrations,
                        });

                    }

                }

                return filteredIntegrations;

            }

            // inactive integrations
            const inactiveIntegrationsObservable = AppIntegrationsInactiveProcessor.getObservable();
            const onNextInactiveIntegration = (data) => {

                const inactiveIntegrations =
                    filterIntegrations(data[$scope.device.relationships.user.data.id]);

                sortServicesToCategory(inactiveIntegrations, 'inactive');

            };
            const inactiveIntegrationsSubscriber = inactiveIntegrationsObservable.subscribe(
                onNextInactiveIntegration,
                () => { },
                () => { },
            );

            // TBD for App details
            if ($scope.state.current.name === 'root.dashboard.device-details.app-details') {

                const { appId } = $state.params;
                $scope.appInstanceDetails =
                    AppInstancesRepository.getByDeviceIdAndAppId($scope.deviceId, appId);

            }

            $scope.showLearnMore = (app, isInstalled, category) => {

                const appId = isInstalled ? app.relationships.app.data.id : app.id;

                Mixpanel.send('ConnectWeb Learn More Click', {
                    Page: 'Device Details',
                    Product: Util.deepFind(app, 'attributes.resource.oeName'),
                    'Product ID': appId,
                });
                if ($scope.showFSSDownloadButton(category) && !isInstalled) {

                    $state.go('root.dashboard.device-details.ltb.activate', {
                        ltb: 'activate',
                        resourceId: $scope.device.id,
                        appId,
                        bundle: defaultDeployedAppId,
                    }, {
                        reload: false,
                    });

                } else if ($scope.servicesByCategory[category].inactive.length === 0
                    || isInstalled) {

                    $state.go('root.dashboard.device-details.ltb.activate', {
                        ltb: 'activate',
                        resourceId: $scope.device.id,
                        appId,
                        installed: true,
                    }, {
                        reload: false,
                    });

                } else {

                    $state.go('root.dashboard.device-details.ltb.activate', {
                        ltb: 'activate',
                        resourceId: $scope.device.id,
                        appId,
                    }, {
                        reload: false,
                    });

                }

            };

            /**
             * Redirect the user to the configured product in the cart when
             * clicking on the offer button
             */
            $scope.getOffer = () => {

                const currentPrice = AppPricesRepository.getSinglePrice('aps10', '12', '1');

                let price = '';
                let discount = '';

                if (currentPrice) {

                    if (Util.deepFind(currentPrice, 'attributes.promotion')) {

                        price = Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                        discount = Util.deepFind(currentPrice, 'attributes.promotion.discount');

                    } else {

                        price = Util.deepFind(currentPrice, 'attributes.price_string');
                        discount = 0;

                    }

                }

                // configure product offer
                const currentOffer = {
                    product: 'Avira Prime',
                    productId: 'aps10',
                };

                Mixpanel.send('ConnectWeb Get Offer Click', {
                    Product: currentOffer.product,
                    ProductId: currentOffer.productId,
                    Page: 'Device Details',
                    Runtimes: '12',
                    Price: price,
                    Discount: discount,
                });

                $state.go('root.dashboard.device-details.ltb.buy', {
                    ltb: 'payment-cart',
                    appId: currentOffer.productId,
                    subsource: 'store_prime',
                    promotion: true,
                }, {
                    reload: false,
                });

            };

            $scope.deployOn = (app, category) => {

                Mixpanel.send('ConnectWeb Install Click', {
                    Page: 'Device Details',
                    Product: Util.deepFind(app, 'attributes.resource.oeName'),
                    'Product ID': app.id,
                });

                const conditionsForAutoInstall = !!((category === 'fss_apps' && $scope.showFSSDownloadButton(category)) ||
                (category === 'internet_of_things' && $scope.device.attributes.os === 'windows'));

                if (conditionsForAutoInstall) {

                    $state.go('root.dashboard.device-details.ltb.deploy', {
                        ltb: 'deploy',
                        resourceId: $scope.device.id,
                        appId: app.id,
                        autoInstall: true,
                    }, {
                        reload: false,
                    });

                } else {

                    $state.go('root.dashboard.device-details.ltb.deploy', {
                        ltb: 'deploy',
                        resourceId: $scope.device.id,
                        appId: app.id,
                    }, {
                        reload: false,
                    });

                }

            };

            /**
             * @param {String} extensionId The extension id for Opera
             * @param {String} appId The app integration id
             */
            $scope.installOperaExtension = (extensionId, appId) => {

                const operaObj = $window.opr || {};

                if (operaObj.addons) {

                    operaObj.addons.installExtension(extensionId);

                } else {

                    let extensionUrl = CWCONFIG.operaExtensions[appId];
                    extensionUrl = extensionUrl.replace('{language}', CWCONFIG.language);

                    $window.open(extensionUrl, '_blank');

                }

            };

            $scope.onTabClick = (tabName) => {

                Mixpanel.send(`ConnectWeb Device Details ${tabName} Click`);

            };

            $scope.removePendingInstance = (instance) => {

                AppInstanceRestService
                    .remove(instance.id)
                    .then(() => {

                        AppInstancesRepository.remove(instance.id);

                    })
                    .then(null, () => {

                        Alert.error({
                            message: 'cw.app.remove.error',
                            icon: {
                                imageUrl: $filter('imageUrlParse')(instance.customAppInfo.icon),
                            },
                        }, {
                            message: {
                                appName: instance.customAppInfo.name,
                            },
                        });

                    });

            };

            $scope.$on('$destroy', () => {

                instancesSubscriber.dispose();
                inactiveIntegrationsSubscriber.dispose();
                devicesSubscriber.dispose();

            });

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/device-details/device-details.js